export default __webpack_public_path__ + "static/media/faq2.60f7dcdc.svg";